import { Row, Col, Select } from 'antd';
import Icon, { DeleteOutlined } from '@ant-design/icons';
import React from 'react';
import styled from 'styled-components';

import { AddsContainer } from './common';

const { Option } = Select;

const IconCol = styled(Col)`
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

function MultiSelect({ icon, title, items }) {
  return (
    <AddsContainer>
      <Row>
        <Col span={1}>
          <Icon type={icon} style={{ fontSize: '32px' }} />
        </Col>
        <Col span={23}>
          <Row>
            <Col span={23} style={{ borderBottom: '1px solid #d9d9d9' }}>
              {title}
            </Col>
            <Col span={1}></Col>
          </Row>
          <Row style={{ marginTop: '10px' }}>
            <Col span={23}>
              <Select
                style={{ width: '100%' }}
                onChange={() => {}}
                mode="multiple"
              >
                {items.map((item, index) => {
                  return (
                    <Option key={index} value={item}>
                      {item}
                    </Option>
                  );
                })}
              </Select>
            </Col>
            <IconCol span={1}>
              <DeleteOutlined style={{ fontSize: '20px', color: 'red' }} />
            </IconCol>
          </Row>
        </Col>
      </Row>
    </AddsContainer>
  );
}

export default MultiSelect;
